import { useState, useMemo, useRef, useEffect } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

const EMOJI_CATEGORIES = [
  {
    label: "Caras",
    emojis: [
      "😀","😃","😄","😁","😆","😅","🤣","😂","🙂","🙃","🫠","😉","😊","😇",
      "🥰","😍","🤩","😘","😗","😚","😙","🥲","😋","😛","😜","🤪","😝","🤑",
      "🤗","🤭","🫢","🫣","🤫","🤔","🫡","🤐","🤨","😐","😑","😶","😏","😒",
      "🙄","😬","🤥","🫨","😌","😔","😪","🤤","😴","😷","🤒","🤕","🤢","🤧",
      "🥵","🥶","🥴","😵","🤯","🤠","🥳","🥸","😎","🤓","🧐","😕","🫤","😟",
      "🙁","😮","😯","😲","😳","🥺","🫹","😦","😧","😨","😰","😥","😢","😭",
      "😱","😖","😣","😞","😓","😩","😫","🥱","😤","😡","😠","🤬","👿","💀",
      "☠️","💩","🤡","👹","👺","👻","👽","👾","🤖",
    ],
  },
  {
    label: "Gestos",
    emojis: [
      "👋","🤚","🖐️","✋","🖖","🫱","🫲","🫳","🫴","🫷","🫸","👌","🤌","🤏",
      "✌️","🤞","🫰","🤟","🤘","🤙","👈","👉","👆","🖕","👇","☝️","🫵","👍",
      "👎","✊","👊","🤛","🤜","👏","🙌","🫶","👐","🤲","🤝","🙏","✍️","💅",
      "🤳","💪","🦾","🦿","🦵","🦶","👂","🦻","👃","🫀","🫁","🧠","🦷","🦴",
      "👀","👁️","👅","👄","🫦","💋",
    ],
  },
  {
    label: "Personas",
    emojis: [
      "👶","🧒","👦","👧","🧑","👱","👨","🧔","👩","🧓","👴","👵","🙍","🙎",
      "🙅","🙆","💁","🙋","🧏","🙇","🤦","🤷","👮","🕵️","💂","🥷","👷","🫅",
      "🤴","👸","👳","👲","🧕","🤵","👰","🤰","🫃","🫄","🤱","👼","🎅","🤶",
      "🧙","🧝","🧛","🧟","🧌","🧞","🧜","🧚","🫧","👯","🕺","💃","🚶","🧍",
      "🧎","🏃","🧖","🧗","🤸","⛹️","🤺","🏇","🏋️","🤼","🤽","🤾","🏌️","🏄",
    ],
  },
  {
    label: "Animales",
    emojis: [
      "🐶","🐱","🐭","🐹","🐰","🦊","🐻","🐼","🐨","🐯","🦁","🐮","🐷","🐸",
      "🐵","🙈","🙉","🙊","🐒","🦆","🐧","🐦","🦅","🦉","🦇","🐺","🐗","🐴",
      "🦄","🐝","🪱","🐛","🦋","🐌","🐞","🐜","🪲","🦟","🦗","🕷️","🦂","🐢",
      "🐍","🦎","🦖","🦕","🐙","🦑","🦐","🦞","🦀","🐡","🐟","🐠","🐬","🐳",
      "🐋","🦈","🐊","🐅","🐆","🦓","🦍","🦧","🦣","🐘","🦛","🦏","🐪","🐫",
      "🦒","🦘","🦬","🐃","🐂","🐄","🐎","🐖","🐏","🐑","🦙","🐐","🦌","🐕",
      "🐩","🦮","🐕‍🦺","🐈","🐓","🦃","🦤","🦚","🦜","🦢","🕊️","🐇","🦝","🦨",
      "🦡","🦫","🦦","🦥","🐁","🐿️","🦔","🐾",
    ],
  },
  {
    label: "Naturaleza",
    emojis: [
      "🌵","🌲","🌳","🌴","🪵","🌱","🌿","☘️","🍀","🎍","🎋","🍃","🍂","🍁",
      "🪸","🌾","💐","🌷","🌹","🥀","🪷","🌺","🌸","🌼","🌻","🪻","🌞","🌝",
      "🌛","🌜","🌚","🌕","🌖","🌗","🌘","🌑","🌒","🌓","🌔","🌙","🌟","⭐",
      "🌠","☁️","⛅","🌤️","⛈️","🌧️","🌨️","🌩️","🌪️","🌫️","🌬️","🌀","🌈","🌂",
      "☔","⚡","❄️","🔥","💧","🌊","🍄","⛄","☃️","🌡️","🌞","🌈",
    ],
  },
  {
    label: "Comida",
    emojis: [
      "🍎","🍐","🍊","🍋","🍌","🍉","🍇","🍓","🫐","🍈","🍑","🥭","🍍","🥥",
      "🥝","🍅","🍆","🥑","🥦","🥬","🥒","🌶️","🫑","🧄","🧅","🥔","🍠","🫘",
      "🌽","🥕","🫛","🧆","🥜","🍞","🥐","🥖","🫓","🥨","🥯","🧀","🥚","🍳",
      "🧈","🥞","🧇","🥓","🥩","🍗","🍖","🦴","🌭","🍔","🍟","🍕","🫔","🌮",
      "🌯","🥙","🧆","🥗","🥘","🫕","🍲","🍜","🍝","🍛","🍣","🍱","🥟","🦪",
      "🍤","🍙","🍚","🍘","🍥","🥮","🍢","🧁","🍰","🎂","🍮","🍭","🍬","🍫",
      "🍿","🍩","🍪","🌰","🥜","🍯","🧃","🥤","🧋","☕","🫖","🍵","🧉","🍺",
      "🍻","🥂","🍷","🥃","🍸","🍹","🧊","🥄","🍴","🥢",
    ],
  },
  {
    label: "Viajes",
    emojis: [
      "🚗","🚕","🚙","🚌","🚎","🏎️","🚓","🚑","🚒","🚐","🛻","🚚","🚛","🚜",
      "🏍️","🛵","🛺","🚲","🛴","🛹","🛼","🛷","🚨","🚔","🚍","🚘","🚖","🚡",
      "🚠","🚟","🚃","🚋","🚞","🚝","🚄","🚅","🚈","🚂","🚆","🚇","🚊","🚉",
      "✈️","🛩️","🛫","🛬","🪂","💺","🚁","🛸","🚀","🛶","⛵","🚤","🛥️","🛳️",
      "⛴️","🚢","⚓","🪝","⛽","🚧","🛞","🚦","🚥","🗺️","🧭","🏔️","⛰️","🌋",
      "🏕️","🏖️","🏜️","🏝️","🏟️","🏛️","🏗️","🧱","🪨","🪵","🛖","🏠","🏡","🏢",
      "🏣","🏤","🏥","🏦","🏨","🏩","💒","🏫","🏬","🗼","🗽","⛪","🕌","🕍",
    ],
  },
  {
    label: "Objetos",
    emojis: [
      "⌚","📱","💻","⌨️","🖥️","🖨️","🖱️","🖲️","💾","💿","📀","📷","📸","📹",
      "🎥","📽️","🎞️","📞","☎️","📟","📠","📺","📻","🧭","⏱️","⏲️","⏰","🕰️",
      "⌛","⏳","📡","🔋","🔌","💡","🔦","🕯️","🪔","🧯","🛢️","💰","💴","💵",
      "💶","💷","💸","💳","🪙","💹","💱","💲","✉️","📧","📨","📩","📤","📥",
      "📦","📫","📪","📬","📭","📮","🗳️","✏️","✒️","🖋️","🖊️","📝","💼","📁",
      "📂","🗂️","📅","📆","🗒️","🗓️","📇","📈","📉","📊","📋","📌","📍","✂️",
      "🗃️","🗄️","🗑️","🔒","🔓","🔏","🔐","🔑","🗝️","🔨","🪓","⛏️","⚒️","🛠️",
      "🗡️","⚔️","🔫","🪃","🏹","🛡️","🪚","🔧","🪛","🔩","⚙️","🗜️","⚖️","🪜",
      "🧲","🪄","🔮","🧿","🎱","🪬","🧸","🪅","🎭","🎨","🖼️","🎰","🎲","♟️",
      "🧩","🎯","🎳","🎮","🎰","🎵","🎶","🎸","🎹","🥁","🪘","🎷","🎺","🎻",
      "🪗","🎤","🎧","📻","🎙️","🎚️","🎛️","📣","📯","🎼","🎬","🎤",
    ],
  },
  {
    label: "Símbolos",
    emojis: [
      "❤️","🧡","💛","💚","💙","💜","🖤","🤍","🤎","💔","❣️","💕","💞","💓",
      "💗","💖","💘","💝","💟","☮️","✝️","☪️","🕉️","✡️","🔯","🕎","☯️","☦️",
      "🛐","⛎","♈","♉","♊","♋","♌","♍","♎","♏","♐","♑","♒","♓",
      "🆔","⚛️","🉑","☢️","☣️","📴","📳","🈶","🈚","🈸","🈺","🈷️","✴️","🆚",
      "💮","🉐","㊙️","㊗️","🈴","🈵","🈹","🈲","🅰️","🅱️","🆎","🆑","🅾️","🆘",
      "❌","⭕","🛑","⛔","📛","🚫","💯","💢","♨️","🚷","🚯","🚳","🚱","🔞",
      "📵","🚭","❗","❕","❓","❔","‼️","⁉️","🔅","🔆","〽️","⚠️","🚸","🔱",
      "⚜️","🔰","♻️","✅","🈯","💹","❎","🌐","💠","Ⓜ️","🌀","💤","🏧","🚾",
      "♿","🅿️","🛗","🈳","🈂️","🛂","🛃","🛄","🛅","🚹","🚺","🚼","⚧️","🚻",
      "🔤","🔡","🔠","🆖","🆗","🆙","🆒","🆕","🆓","0️⃣","1️⃣","2️⃣","3️⃣","4️⃣",
      "5️⃣","6️⃣","7️⃣","8️⃣","9️⃣","🔟","🔢","#️⃣","*️⃣","⏏️","▶️","⏸️","⏹️","⏺️",
      "⏭️","⏮️","⏩","⏪","⏫","⏬","◀️","🔼","🔽","➡️","⬅️","⬆️","⬇️","↗️",
      "↘️","↙️","↖️","↕️","↔️","↪️","↩️","⤴️","⤵️","🔀","🔁","🔂","🔃","🎵",
      "🎶","➕","➖","➗","✖️","♾️","💲","💱","™️","©️","®️","〰️","➰","➿","🔚",
      "🔙","🔛","🔝","🔜","✔️","☑️","🔘","🔲","🔳","⚫","⚪","🟤","🔴","🟠",
      "🟡","🟢","🔵","🟣","🟥","🟧","🟨","🟩","🟦","🟪","⬛","⬜","▪️","▫️",
      "◾","◽","◼️","◻️","🔶","🔷","🔸","🔹","🔺","🔻","💠","🔘","🔳","🔲",
    ],
  },
  {
    label: "Banderas",
    emojis: [
      "🏁","🚩","🎌","🏴","🏳️","🏳️‍🌈","🏳️‍⚧️","🏴‍☠️",
      "🇺🇸","🇬🇧","🇪🇸","🇫🇷","🇩🇪","🇮🇹","🇵🇹","🇲🇽","🇧🇷","🇦🇷",
      "🇨🇱","🇨🇴","🇵🇪","🇻🇪","🇺🇾","🇪🇨","🇧🇴","🇵🇾","🇨🇺","🇩🇴",
      "🇯🇵","🇨🇳","🇰🇷","🇮🇳","🇦🇺","🇨🇦","🇷🇺","🇺🇦","🇳🇱","🇧🇪",
      "🇸🇪","🇳🇴","🇩🇰","🇫🇮","🇨🇭","🇦🇹","🇵🇱","🇬🇷","🇹🇷","🇮🇱",
      "🇸🇦","🇦🇪","🇿🇦","🇳🇬","🇰🇪","🇪🇬","🇲🇦","🇹🇭","🇻🇳","🇮🇩",
      "🇵🇭","🇲🇾","🇸🇬","🇳🇿","🇮🇷","🇮🇶","🇵🇰","🇧🇩","🇱🇰",
    ],
  },
];

export default function EmojiPickerPopover({ value, onSelect, children }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const searchRef = useRef(null);

  useEffect(() => {
    if (open) {
      setSearch("");
      setTimeout(() => searchRef.current?.focus(), 80);
    }
  }, [open]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return EMOJI_CATEGORIES;
    return EMOJI_CATEGORIES.map((cat) => ({
      ...cat,
      emojis: cat.emojis.filter((e) => {
        try {
          const name = e.codePointAt(0).toString(16);
          return e.includes(q) || name.includes(q) || cat.label.toLowerCase().includes(q);
        } catch {
          return false;
        }
      }),
    })).filter((c) => c.emojis.length > 0);
  }, [search]);

  const handlePick = (emoji) => {
    onSelect(emoji);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        className="w-80 p-0 overflow-hidden"
        side="bottom"
        align="start"
        sideOffset={6}
      >
        <div className="p-2 border-b border-neutral-100 bg-white sticky top-0 z-10">
          <Input
            ref={searchRef}
            className="h-8 text-sm"
            placeholder="Buscar emoji…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="overflow-y-auto max-h-72 p-1">
          {filtered.length === 0 ? (
            <p className="text-xs text-neutral-400 text-center py-6">Sin resultados</p>
          ) : (
            filtered.map((cat) => (
              <div key={cat.label}>
                <p className="text-[10px] font-semibold uppercase tracking-wider text-neutral-400 px-1.5 pt-2 pb-1">
                  {cat.label}
                </p>
                <div className="flex flex-wrap gap-0.5">
                  {cat.emojis.map((emoji, i) => (
                    <button
                      key={`${emoji}-${i}`}
                      type="button"
                      onClick={() => handlePick(emoji)}
                      className={cn(
                        "h-8 w-8 flex items-center justify-center rounded text-xl hover:bg-neutral-100 transition-colors",
                        value === emoji && "bg-neutral-100 ring-1 ring-neutral-300"
                      )}
                      title={emoji}
                    >
                      {emoji}
                    </button>
                  ))}
                </div>
              </div>
            ))
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
